<template>
  <div class="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 tw-p-4">
    <div
      class="tw-max-w-md tw-w-full tw-bg-white tw-rounded-2xl tw-shadow-xl tw-overflow-hidden tw-border tw-border-gray-100 tw-transition-all tw-duration-500 hover:tw-shadow-2xl"
    >
      <div class="tw-h-2 tw-bg-red-500"></div>
      <div class="tw-p-8 tw-text-center">
        <div class="tw-inline-flex tw-items-center tw-justify-center tw-w-20 tw-h-20 tw-bg-red-50 tw-rounded-full tw-mb-6 tw-animate-pulse">
          <svg xmlns="http://www.w3.org/2000/svg" class="tw-h-10 tw-w-10 tw-text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <p class="tw-text-gray-600 tw-mb-8 tw-leading-relaxed">
          A login error occurred, please contact your support team
        </p>

        <div class="tw-space-y-4">
          <button
            @click="logout"
            class="tw-block tw-w-full tw-py-3 tw-px-4 tw-bg-white tw-text-gray-600 tw-font-semibold tw-rounded-lg tw-border tw-border-gray-200 tw-transition-all tw-duration-200 hover:tw-bg-gray-50"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginErrorView",
  methods: {
    logout() {
      this.$router.push("/signout");
    },
  },
};
</script>

<style scoped>
.tw-bg-white {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}
</style>
